import apiClient from './apiClient';

export const getTripSheetsByClientId = async (clientId) => {
  try {
    const response = await apiClient.get(`/client/${clientId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
